import Batch from './batch'

const batch = new Batch()
batch.init()

if ('serviceWorker' in navigator) {
	navigator.serviceWorker
		.register('/batchsdk-worker-loader.js')
		.then((reg) => {
			// registration worked
			console.debug(`Registration succeeded. Scope is ${reg.scope}`)
		})
		.catch((error) => {
			// registration failed
			console.error(`Registration failed with ${error}`)
		})
}
